import { render, staticRenderFns } from "./solucion-resumen.vue?vue&type=template&id=ff918904&scoped=true&"
import script from "./solucion-resumen.component.ts?vue&type=script&lang=ts&"
export * from "./solucion-resumen.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff918904",
  null
  
)

export default component.exports